import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import styled, { css, useTheme } from "styled-components";
import Icon from "~/components-shared/Icon";
import Label from "~/components-shared/Label";
import { genericColor } from "~/lib/resolvers";
const Wrapper = styled.div`
  ${_ref => {
  let {
    $s,
    theme
  } = _ref;
  return theme.spacing.resolve(theme, $s);
}};
  display: flex;
  flex-direction: row;
  align-items: center;
`;
const StyledIcon = styled(Icon)`
  cursor: pointer;
  position: relative;
  z-index: 1;

  &:before {
    content: "";
    position: absolute;
    top: -3px;
    left: -3px;
    width: calc(100% + 6px);
    height: calc(100% + 6px);
    transition: background-color 200ms ease-out;
    background-color: transparent;
    border-radius: 50%;
    z-index: -1;
  }

  ${_ref2 => {
  let {
    $disabled
  } = _ref2;
  return !$disabled && css`
      &:hover:before {
        background-color: ${_ref3 => {
    let {
      theme
    } = _ref3;
    return theme.colors.action.hover;
  }};
      }
    `;
}}
`;
const Outline = styled.div`
  width: ${_ref4 => {
  let {
    $scale,
    theme
  } = _ref4;
  return theme.typography.fontStep * $scale;
}}rem;
  height: ${_ref5 => {
  let {
    $scale,
    theme
  } = _ref5;
  return theme.typography.fontStep * $scale;
}}rem;
  border-radius: 50%;
  ${_ref6 => {
  let {
    $outline,
    theme
  } = _ref6;
  return theme.shadows.outline(theme, $outline);
}}
`;
const Input = styled.input`
  opacity: 0;
  width: 0;
`;
const InputRadio = _ref7 => {
  let {
    name,
    label,
    value,
    checked = false,
    error,
    onChange = () => false,
    required = false,
    disabled = false,
    scale = 5,
    color = "translucent",
    s,
    outline,
    children,
    labelProps,
    ...rest
  } = _ref7;
  const theme = useTheme();
  return /*#__PURE__*/React.createElement(Wrapper, {
    $s: s
  }, /*#__PURE__*/React.createElement(Outline, {
    $outline: outline,
    $scale: scale
  }, /*#__PURE__*/React.createElement(StyledIcon, {
    scale: scale,
    src: checked ? "radioFill" : "radio",
    onClick: () => disabled ? false : onChange(!value),
    $disabled: disabled,
    color: disabled ? theme.colors.text.disabled : genericColor(theme, color),
    display: "block"
  }), /*#__PURE__*/React.createElement(Input, _extends({}, rest, {
    type: "radio",
    name: name,
    value: value,
    disabled: disabled,
    checked: checked
  }))), !!label && /*#__PURE__*/React.createElement(Label, _extends({
    s: {
      ml: 1.5
    },
    onClick: () => disabled ? false : onChange(!value),
    required: required,
    disabled: disabled
  }, labelProps), label));
};
export default InputRadio;